import customerService from "@/services/customer";
import { useQuery } from "@tanstack/react-query";

type Props = {
  phoneNumber: string;
  enabled?: boolean;
};

function useGetCustomerByPhoneNumber({ phoneNumber }: Props) {
  const { data, isLoading, refetch, isFetching, isSuccess, isError } = useQuery(
    ["getCustomerByPhoneNumber", phoneNumber],
    () => customerService.getCustomerByPhoneNumber(phoneNumber),
    {
      enabled: Boolean(phoneNumber) && phoneNumber?.length === 11,
    },
  );

  return { data, isLoading: isFetching && isLoading, refetch, isSuccess, isError };
}

export function useGetCustomerInMerchantByPhoneNumber({ phoneNumber, enabled = false }: Props) {
  return useQuery(
    ["getCustomerInMerchantByPhoneNumber", phoneNumber],
    () => customerService.getCustomerInMerchantByPhoneNumber(phoneNumber),
    {
      enabled: enabled && /^09\d{9}$/.test(phoneNumber),
    },
  );
}

export default useGetCustomerByPhoneNumber;
